<apex-client-addon-breadcrumb
  [apartment]="apartment"
  [cart]="null">
</apex-client-addon-breadcrumb>

<div class="order-return-container amt apt">
  <mat-card class="result-card mat-elevation-z4">
    <mat-card-content>
      <div class="result-content">
        <!-- Success Icon -->
        <mat-icon
          *ngIf="success"
          class="result-icon success-icon"
          color="primary">
          check_circle
        </mat-icon>

        <!-- Error Icon -->
        <mat-icon
          *ngIf="!success"
          class="result-icon error-icon"
          color="warn">
          error_outline
        </mat-icon>

        <!-- Title -->
        <h1
          class="mat-headline-4 result-title"
          *ngIf="success">
          <T str="Order Completed!"></T>
        </h1>

        <h1
          class="mat-headline-4 result-title"
          *ngIf="!success">
          <T str="Order Failed"></T>
        </h1>

        <!-- Message -->
        <p class="mat-body-1 result-message">
          <ng-container *ngIf="success">
            <T str="Your package order has been successfully signed and submitted!"></T>
          </ng-container>
          <ng-container *ngIf="!success">
            <T
              str="There was an issue completing your order for the addon package. The package has been reserved for an hour. Please try again after an hour."></T>
          </ng-container>
        </p>

        <!-- Success Actions -->
        <div
          class="result-actions"
          *ngIf="success">
          <a
            mat-raised-button
            color="primary"
            [routerLink]="['/', 'project', apartment?.ProjectId, 'apartment', apartment?.id, 'addon']">
            <T str="Back to Addons"></T>
          </a>
        </div>

        <!-- Error Actions -->
        <div
          class="result-actions"
          *ngIf="!success">
          <a
            mat-raised-button
            [routerLink]="['/', 'project', apartment?.ProjectId, 'apartment', apartment?.id]">
            <T str="Home"></T>
          </a>
          <a
            mat-raised-button
            color="primary"
            [routerLink]="['/', 'project', apartment?.ProjectId, 'apartment', apartment?.id, 'addon']">
            <T str="View Addons"></T>
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
